export enum FloorPlanPartyType {
  serving = 'Serving',
  waiting = 'Waiting',
  booked = 'Booked',
  checkedIn = 'Checked In',
  overdue = 'Overdue',
}
